import { Box, SelectComponents } from '@frontend/legacy-components';

import { UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';
import { ELLIPSIS_PROPS } from 'modules/common/styles';

import { ANYBODY_VALUE } from '../const';

export const SingleValue = ({ children, ...restProps }) => {
  const selectValue = restProps.getValue();
  const { value, isDeleted, email } =
    (Array.isArray(selectValue) ? selectValue[0] : selectValue) ?? {};

  return (
    <SelectComponents.SingleValue {...restProps}>
      {value !== UNASSIGNED_VALUE && value !== ANYBODY_VALUE && isDeleted ? (
        <Box
          as="span"
          fontStyle="italic"
          color="feature.secondary"
          {...ELLIPSIS_PROPS}
        >{`${email} (deleted)`}</Box>
      ) : (
        children
      )}
    </SelectComponents.SingleValue>
  );
};
